var antPrefixCls = '.ant-popover';
var popoverStyleFn = function popoverStyleFn(token) {
  var _antPrefixCls, _ref;
  return _ref = {}, _ref[antPrefixCls] = (_antPrefixCls = {}, _antPrefixCls[antPrefixCls + "-inner"] = {
    padding: token.popoverPadding
  }, _antPrefixCls), _ref;
};

export { popoverStyleFn };
